import styled from "styled-components";

export const Withdrawal = styled.div`
  display: -webkit-box;
  display: flex;
  margin: auto;
  padding: 16px;
  flex-direction: column;
  flex-grow: 1;
`;

export const WithdrawalSection = styled.section`
  display: -webkit-box;
  display: flex;
  max-width: 600px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
`;

export const WithdrawalTit = styled.div`
  display: -webkit-box;
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  font-size: 2.2rem;
  font-weight: 500;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;

  svg {
    width: 90%;
    margin-bottom: 10px;
  }
`;

export const WithdrawalBox = styled.div`
  display: -webkit-box;
  display: flex;
  width: 100%;
  padding: 30px;
  background: white;
  box-shadow: 0 2px 10px -4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;

  & + & {
    margin-top: 10px;
  }
`;

export const TitBox = styled.div`
  width: 100%;
  margin-bottom: "20px";
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: -0.1rem;

  span {
    color: #df6464;
  }
`;

export const ContentBox = styled.div`
  padding: 0 10px;
  font-size: 1.5rem;
  letter-spacing: -0.07rem;

  p {
    margin-bottom: 0;

    & + p {
      margin-top: 5px;
    }

    span.underline {
      color: ${(props) => props.theme.colors.primary};
      font-weight: 600;
      text-decoration: underline;
    }
  }
`;

export const UnderlineSpan = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-weight: 600;
  text-decoration: underline;
`;

export const ContentSubBox = styled.div`
  width: 100%;
  margin-bottom: 10px;
  color: #797979;
  font-size: 1.2rem;
  letter-spacing: -0.07rem;
`;

export const StyledTable = styled.table`
  margin-top: 20px;
  margin-bottom: 0;
  border: none;

  thead {
    tr {
      th {
        padding: 6px;
        color: white;
        font-size: 1.2rem;
        text-align: center;
        background: ${(props) => props.theme.colors.primary};
        border-bottom: none;

        &:first-child {
          border-radius: 4px 0 0 4px;
        }

        &:last-child {
          border-radius: 0 4px 4px 0;
        }
      }
    }
  }

  tbody {
    td {
      padding: 10px;
      color: #2b2f45;
      font-size: 1.4rem;
      font-weight: 500;
      text-align: center;
      vertical-align: middle;
      background: #f9f9f9;
      border-top: none;

      &:first-child {
        width: 80px;
        color: #797979;
        font-size: 1.2rem;
        font-weight: 400;
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
`;

export const InputForm = styled.form`
  width: 100%;

  button {
    width: 100%;
    height: 48px;
    margin-top: 30px;
    color: white;
    font-size: 1.6rem;
    font-weight: 500;
    background: ${(props) => props.theme.colors.primary};
    border: none;
    border-radius: 5px;

    &:active {
      background: #2b39d0;
    }
  }
`;

export const InputBox = styled.label`
  display: -webkit-box;
  display: flex;
  width: 100%;
  color: #797979;
  flex-direction: column;

  input {
    height: 40px;
    padding: 0 10px;
    border: 1px solid #dfdfdf;
    border-radius: 5px;
  }

  & + & {
    margin-top: 10px;
  }
`;

export const ErrorMessage = styled.p`
  color: red;
`;

export const WithdrawalFooter = styled.div`
  display: -webkit-box;
  display: flex;
  width: 100%;
  height: 40px;
  margin-top: 16px;
  color: #2b2f45;
  font-size: 1.6rem;
  letter-spacing: -0.07rem;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 5px;
  }
`;

export const InputContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 1.5%;
`;

export const InputContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const InputBoxLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;

  label {
    padding-left: 4px;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray};
  }

  .error-text {
    padding-left: 6px;
    color: ${(props) => props.theme.colors.red};
  }
`;
export const LabelContextBox = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;
